module.exports = "../../../../platform/assets/pageMainIcon/simple_yewushezhilei1.svg";